import { render, staticRenderFns } from "./CompanyBody.vue?vue&type=template&id=3d633b0e&scoped=true&"
import script from "./CompanyBody.vue?vue&type=script&lang=js&"
export * from "./CompanyBody.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBody.vue?vue&type=style&index=0&id=3d633b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d633b0e",
  null
  
)

export default component.exports